import { loginStore } from "@/modules/login/store";
import { accelerationStore } from "@/stores/acceleration";
import { Box, Flex, Text, chakra, useBoolean } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Check } from "../../../components/Icons";
import AcceleratePayment from "../AcceleratePayment";
import PayModalWithTable from "./PayModalWithTable";

function VipUpgradeModal() {
  const [open, setOpen] = useBoolean(false);
  const [payOpen, setPayOpen] = useBoolean(false);
  const onPurchase = () => {
    setOpen.off();
    setPayOpen.on();
  };
  useEffect(() => {
    if (loginStore.authorization && !localStorage.getItem("vipUpgradeWarn")) {
      const registerTime = loginStore.userState.userInfo.createdAt!;
      // TODO: 更改实际上线日期
      // 2023-2-10 00:00
      if (new Date(registerTime).getTime() < 1675958400000) {
        setOpen.on();
        localStorage.setItem("vipUpgradeWarn", "1");
      }
    }
  }, []);

  const { isVip } = accelerationStore;

  return (
    <>
      <PayModalWithTable
        isOpen={open}
        onClose={setOpen.off}
        title=""
        content={
          <Flex flexDirection="column" color="text.subtitle" fontSize="14px" px="40px">
            <Text
              fontSize="24px"
              mt="-40px"
              mb="24px"
              fontWeight={600}
              textAlign="center"
              color="white"
            >
              「画宇宙」功能权益更新 🎉
            </Text>
            <Text mb="6px">画宇宙的用户：</Text>
            <Text mb="6px">您好</Text>
            <Text mb="6px" sx={{ textIndent: "2em" }}>
              「画宇宙」新版本上线了更多模型和批量做图等功能 😝，用户权益也进行了更新。
            </Text>
            <Text mb="6px" sx={{ textIndent: "2em" }}>
              免费用户每天登录将获赠 30 免费画力星
              ⭐，使用产品功能将会消耗相应画力星；会员用户可不限量使用画宇宙系列模型功能。
            </Text>
            <Text mb="6px" sx={{ textIndent: "2em" }}>
              感谢各位用户在早期对画宇宙产品的支持
              😘。为了表达我们的感谢，我们将对您的已有权益做如下调整和赠送：
            </Text>
            <Flex mt="20px">
              <Box h="100%" w="32px" flex="none">
                <Check boxSize="20px" />
              </Box>
              <Text>免费用户可一次性获赠 100 免费画力星</Text>
            </Flex>
            <Flex>
              <Box h="100%" w="32px" flex="none">
                <Check boxSize="20px" />
              </Box>
              <Text>
                当前正在使用的算力加速通道权益将升级为画宇宙会员权益，画宇宙会员的剩余时长 =
                之前算力加速通道剩余时长 * 2
              </Text>
            </Flex>
            <Flex>
              <Box h="100%" w="32px" flex="none">
                <Check boxSize="20px" />
              </Box>
              <Text>付费画力星剩余数量 = 已购买的画力星剩余数量 * 15</Text>
            </Flex>
            <Flex justify="center" mt="70px">
              <chakra.button
                w="165px"
                h="38px"
                rounded="4px"
                color="black"
                mr="12px"
                bg={`linear-gradient(-90deg, #F0BF68, #F9E5AE);`}
                onClick={onPurchase}
              >
                {isVip ? "续费会员" : "开通会员"}
              </chakra.button>
              <chakra.button
                w="165px"
                h="38px"
                rounded="4px"
                border="1px solid"
                onClick={setOpen.off}
              >
                我知道了
              </chakra.button>
            </Flex>
          </Flex>
        }
      />
      <AcceleratePayment open={payOpen} onClose={setPayOpen.off} />
    </>
  );
}

export default observer(VipUpgradeModal);
